import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const organisationalApprovalMutation = gql`
  mutation OrganisationalApproval($orderId: ID!, $status: String!, $rejection_reasons: [PayrollOrderReason], $additional_comment: String) {
    organisationalApproval(
      orderId: $orderId
      status: $status
      rejection_reasons: $rejection_reasons
      additional_comment: $additional_comment
    )
  }
`

export const organisationalApprovalKey = getQueryNames(organisationalApprovalMutation)[0]
